import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Questionnaire from './views/Questionnaire.vue';
import Submission from './views/Submission.vue';
import Store from './store';

Vue.use(Router);

function authenticated(to : any, from : any, next : any) {
  if (Store.getters.getToken() != null && Store.getters.getToken() != '') {
    next();
  } else {
    next('/');
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: Home,
    // },
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/q/:submissionId',
      name: 'questionnnaire',
      component: Questionnaire,
    },
    {
      path: '/submission',
      name: 'submission',
      component: Submission,
      beforeEnter: authenticated,
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});